import { Box, Flex, Icon, Skeleton, Text } from 'components'

import styled from 'styled-components'

import { formatDatetime } from 'utils/datetime'
import { getLeadStatusChipGroup, getLeadOwnerName } from 'modules/Leads/MergeLead/components/helpers'

import { LeadDetail } from 'store/types/lead'
import LeadStatusChipV2 from '../../LeadStatus/LeadStatusV2'

type Props = {
  leadDetail?: Partial<LeadDetail> | null
  isLeadDataLoading?: boolean
}

export const BasedOnBox = ({ leadDetail, isLeadDataLoading }: Props) => {
  const statusChipGroup = getLeadStatusChipGroup(leadDetail?.leadStatusName)
  return (
    <>
      {isLeadDataLoading ? (
        <Box width="50%">
          <Skeleton width="100%" height="70px" />
        </Box>
      ) : (
        <MergeLeadBox flexShrink={0}>
          {leadDetail == null ? (
            <Text margin="auto" fontSize="13px" color="gray5">
              select_lead_to_merge_lbl
            </Text>
          ) : (
            <>
              <Flex gap="6px" flexWrap="wrap">
                <Text ellipsis whiteSpace="nowrap" maxLength={55} fontSize={14} color="gray7" fontWeight="bold">
                  {leadDetail?.leadName}
                </Text>
                {statusChipGroup && <LeadStatusChipV2 statusGroup={statusChipGroup} />}
                <Text
                  ellipsis
                  whiteSpace="nowrap"
                  maxLength={55}
                  fontSize={13}
                  color={getLeadOwnerName(leadDetail) === 'unassigned_lbl' ? 'red1' : 'gray5'}
                >
                  {getLeadOwnerName(leadDetail)}
                </Text>
                <Icon icon={['fa', 'circle']} color="gray5" fontSize="6px" />
                <Text fontSize={13} color="gray5">
                  Last activity:{' '}
                  {leadDetail?.lastActivity?.lastActivityTs
                    ? formatDatetime(leadDetail?.lastActivity?.lastActivityTs, 'PPPp')
                    : '-'}
                </Text>
              </Flex>
            </>
          )}
        </MergeLeadBox>
      )}
    </>
  )
}

const MergeLeadBox = styled(Flex)`
  border: 1px solid ${(p) => p.theme.colors.gray3};
  border-radius: 6px;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  background: white;
  flex-shrink: 0;
`
